import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '../index'

const selectCommentsById = (state: RootState) => state.comments.byId
const selectCommentsAllIds = (state: RootState) => state.comments.allIds

export const selectAllComments = createSelector(
    [selectCommentsById, selectCommentsAllIds],
    (byId, allIds) => allIds.map((id: string) => byId[id]).filter(Boolean)
)

export const selectCommentsByTaskId = createSelector(
    [selectAllComments, (_state: RootState, taskId: string) => taskId],
    (comments, taskId) => comments.filter((c: any) => c.taskId === taskId)
)

export const selectCommentsLoading = (state: RootState) => state.comments.loading
